import type { ToneOverlay } from "../index.js";

// Voz "dark" en galego: retranca pura — ironía indirecta, ambigüidade e fatalismo con
// sorna. Humor propio, non unha tradución. Opcional; a voz seria segue sendo a
// predeterminada. As liñas con variantes rotan cada dúas horas (TONE_ROTATE_MS). Cada
// variante conserva os {marcadores} da base (verifícao tone-guardrail.test.ts).
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} preto. E logo?",
    "{hazard} preto. Pois xa estamos.",
    "{hazard} preto. Haberá que ver.",
    "{hazard} preto. Como non ía.",
    "{hazard} preto. Mira ti que ben.",
  ],
  "alert.toast.escalation": [
    "O {hazard} foi a peor. E logo había ir a mellor?",
    "O {hazard} sobe. Pois cara a peor, claro.",
    "O {hazard} a máis. Só non mellora, non.",
    "O {hazard} vénse arriba. Que ledicia.",
  ],
  "alert.toast.inPath": [
    "O {hazard} vai a por ti. Si, ti. Move.",
    "O {hazard} colleuche cariño. Foxe.",
    "O {hazard} vai directo a ti. Hoxe non, grazas.",
    "O {hazard} co teu nome posto. Marcha.",
  ],
  "alert.toast.allClear": [
    "Aínda vivo preto de {place}. Algo é algo.",
    "{place} non te colleu. Por esta vez.",
    "Sobreviviches a {place}. Apúntao.",
    "Todo tranquilo preto de {place}. Ata a próxima.",
  ],
  "alert.toast.tap": [
    "Toca para o plan de non finar.",
    "Toca, que aquí está como seguir vivo.",
    "Toca. As instrucións de respirar, dentro.",
  ],
  "alert.takeover.title": [
    "{hazard} — hoxe tócache ser protagonista. Veña.",
    "{hazard} — a parte de correr da peli. Corre.",
    "{hazard} — actúa xa, as queixas despois.",
  ],
  "alert.takeover.details": "Os detalles, co seu aquel",
  "alert.takeover.dismiss": "Sobrevivido, pechar",
  "now.status.allClear": [
    "Aínda aquí. Mira ti.",
    "Aínda respirando. Vaites.",
    "Estatisticamente, ben.",
    "Tranquilo. Tranquilo de máis.",
    "Vivo e aburrido. O ideal.",
    "Sen novidade. Polo de agora.",
    "Nin fu nin fa. Perfecto.",
  ],
  "now.status.stayAware": [
    "Ollo, que nunca se sabe.",
    "Non te fíes nin da túa sombra.",
    "Un ollo aberto, por se acaso.",
    "Esta é a parte tranquila. Goza.",
    "Non te confíes, anda.",
    "Ti vixía, non vaia ser.",
  ],
  "now.status.sub.allClear": [
    "Nada que queira matarte no radio. Milagre.",
    "Sen perigos preto. Desconfía igual.",
    "O radio, limpo. De momento.",
    "Nada no radar. A ver canto dura.",
    "Todo en calma. Demasiada calma.",
    "Nada á vista. O universo anda noutra.",
  ],
  "now.activity.empty": [
    "Sospeitosamente tranquilo, ho.",
    "Nada. Case de mala educación.",
    "Isto está máis morto ca o agosto.",
    "Nin unha alma. Grilos.",
    "Cero novas. Facemos coma se fose bo.",
    "Silencio. Mala espiña, pero silencio.",
  ],
  "onboarding.promise.tagline": "Veciños mantendo veciños sobre o chan.",
  "onboarding.promise.continue": "Sobrevivamos a isto",
  "onboarding.home.browse": "Só curioseando o apocalipse",
  "you.voice.intro": "Escolle o teu estilo de malas novas.",
};
